// **********************************************************
// Gallery Slider
// **********************************************************

const gallerySlider = document.querySelectorAll('[data-slider="gallery-slider"]');

const gallerySliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 30,
  speed: 1000,
  watchOverflow: true,
  centerInsufficientSlides: true,
  watchSlidesProgress: true,
  freeMode: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: false,
    type: 'custom',
    renderCustom(swiper, current) {
      return `<span class="swiper-current-index">${current}</span><span> / </span><span class="swiper-total-slides">${swiper.slides.length}</span>`;
    },
  },
  on: {
    snapGridLengthChange() {
      if (this.snapGrid.length !== this.slidesGrid.length) {
        this.snapGrid = this.slidesGrid.slice(0);
      }
    },
  },
  breakpoints: {
    767: {
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: false,
    },
  },
};

gallerySlider.forEach((el) => {
  const parentElem = el.closest('.gallery-slider');
  const innerEle = parentElem.querySelector('.gallery-slider__body');
  const paginationElement = parentElem.querySelector('.swiper-pagination');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  gallerySliderOptions.pagination.el = paginationElement;
  gallerySliderOptions.navigation.prevEl = arrowLeft;
  gallerySliderOptions.navigation.nextEl = arrowRight;

  // Calc Image Width
  const updateWidth = (img, slide) => {
    const width = Math.round(img.getBoundingClientRect().width);
    slide.style.setProperty('--image-width', `${width}px`);
  };

  const updateLastSlidePadding = (lastImage) => {
    const bodyWidth = innerEle.getBoundingClientRect().width;
    const slideWidth = lastImage.getBoundingClientRect().width;
    if (slideWidth < bodyWidth)
      innerEle.style.setProperty('--last-slide-empty-width', `${Math.floor(bodyWidth - slideWidth)}px`);
  };

  const allImages = parentElem.querySelectorAll('.gallery-slider__image img');
  if (allImages.length === 0) return;
  const lastImage = allImages[allImages.length - 1];

  allImages.forEach((img) => {
    const parentEle = img.closest('.gallery-slider__slide-inner');

    const handleReady = async () => {
      // waits even if image is already cached / local
      if (img.decode) {
        try {
          await img.decode();
        } catch (_) {
          // ignore decode errors, browser will still render
        }
      }

      updateWidth(img, parentEle);

      if (img === lastImage) {
        requestAnimationFrame(() => updateLastSlidePadding(lastImage));
      }
    };

    if (img.complete) {
      handleReady();
    } else {
      img.addEventListener('load', handleReady, { once: true });
    }
  });

  new Swiper(el, gallerySliderOptions);
});
